import { DecisionStatsMultipleChoiceItem } from "./DecisionStatsMultipleChoiceItem";

export default DecisionStatsMultipleChoiceItem;